import React from 'react';

import { Teamlist } from 'components';
import useTeamStandings from "hooks/useTeamStandings";

const SLICE = 5;

const TeamStandings = () => {

    const { teamStandings, isLoading } = useTeamStandings('current');

    const teamlistData = [...(teamStandings || [])]
        .sort((a, b) => b.totalPoints - a.totalPoints)
        .slice(0, SLICE);

    return <Teamlist teamlistData={teamlistData} isLoading={isLoading} size='small' />
}

export default TeamStandings;
